import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  CanvasElement,
  CanvasNamespaceId,
  LayoutUiLayerProperties,
} from '@blaze-runtime/engine-domain';
import { LayoutV2Info, SaveLayoutV2Request } from '@blaze-shared/api-contracts-domain';
import { DEV_SUBDOMAIN_OVERRIDE, XhrService } from '@blaze-shared/platform-data-access';
import { LayoutStyleReferencesInfo } from '@blaze-shared/theming-domain';
import { Connection } from '@blaze-shared/workflow-domain';

export interface LayoutsApiDataResponse extends LayoutV2Info {
  actionLayer: {
    connections: Connection[];
  };
  pageId: CanvasNamespaceId;
  uiLayer: {
    content: CanvasElement[];
    properties?: LayoutUiLayerProperties;
  };
}

export interface LayoutsApiDataRequest extends SaveLayoutV2Request {
  actionLayer?: {
    connections: Connection[];
  };
  pageId: CanvasNamespaceId;
  uiLayer?: {
    content: CanvasElement[];
    properties?: LayoutUiLayerProperties;
  };
  styles?: LayoutStyleReferencesInfo[];
}

@Injectable({ providedIn: 'root' })
// TODO: test
export class LayoutsApiService {
  private readonly devSubdomainOverride = inject(DEV_SUBDOMAIN_OVERRIDE);
  private readonly xhrService = inject(XhrService);

  fetchLayoutFile(layoutUrl: string): Observable<LayoutsApiDataResponse> {
    if (this.devSubdomainOverride) {
      layoutUrl = `//` + `${this.devSubdomainOverride}${layoutUrl}`.replaceAll('//', '/');
    }
    return this.xhrService.fetch<LayoutsApiDataResponse>(layoutUrl);
  }

  /**
   * Do not use directly. Please use layout-loading.service getLayout instead.
   * @param pageId
   * @returns
   */
  getLayout(pageId: string): Observable<LayoutsApiDataResponse> {
    return this.xhrService.get<LayoutsApiDataResponse>('layouts/v2', { pageId });
  }

  updateLayouts(layouts: LayoutsApiDataRequest[]): Observable<LayoutsApiDataResponse[]> {
    return this.xhrService.post<LayoutsApiDataResponse[], LayoutsApiDataRequest[]>(
      'layouts/v2/batch',
      layouts,
    );
  }
}
